export const SET_LIST = "members/SET_LIST";
export const SET_INDUSTRY_LIST = "members/SET_INDUSTRY_LIST"
export const SET_MEMBER = "members/SET_MEMBER"